import { getAllmaterials } from '../dataProviders/admin/materials';
import type { Order } from '../types/Order';
import useDataQuery from './useDataQuery';

export function useOrderColor(order: Order | undefined) {
  const { data: dentalMaterials, isLoading: areMaterialsLoading } = useDataQuery({ query: getAllmaterials, uniqueKey: 'formMaterials', useCache: 'short' });
  const clrPrefix = computed(() => {
    const orderTypeWithoutColors = order?.machine_type === '3d' || order?.machine_type === 'models';
    if (areMaterialsLoading.value || !order || orderTypeWithoutColors || !order.material_id) {
      return '';
    }
    const material = dentalMaterials.value?.find(e => e.id === order.material_id);
    if (!material) {
      return '';
    }
    return `${material.name.replace(/ /g, '_')}-${order.color}`;
  });

  return { clrPrefix };
}
